import React, { useRef } from "react"
import Slider from "react-slick"
import WOW from "react-wow"
import { Element } from "react-scroll"

import Icons from "./icons"
import * as S from "./styled"

const AboutSlider = ({ items }) => {
  const sliderRef = useRef(null)

  const settings = {
    dots: true,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToScroll: 1,
    draggable: true,
    initialSlide: Math.floor(items.length / 2),
    centerMode: true,
    centerPadding: 0,
    slidesToShow: 3,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const NextIcon = Icons.ChevronRight

  return (
    <Element name="slider-servicos">
      <S.AboutSliderWrapper>
        <WOW animation="zoomIn">
          <Slider ref={sliderRef} {...settings}>
            {items.map((item, i) => {
              const MainIcon = item.icon ? Icons[item.icon] : Icons["Web"]

              return (
                <S.AboutSliderItem key={i}>
                  <S.AboutSliderItemIcon>
                    <MainIcon />
                  </S.AboutSliderItemIcon>
                  <S.AboutSliderItemTitle>{item.title}</S.AboutSliderItemTitle>
                  <S.AboutSliderItemDesc>
                    {item.description}
                  </S.AboutSliderItemDesc>
                  <S.AboutSliderItemNext
                    onClick={() => sliderRef.current.slickNext()}
                    aria-label="Próximo item"
                  >
                    <NextIcon />
                  </S.AboutSliderItemNext>
                </S.AboutSliderItem>
              )
            })}
          </Slider>
        </WOW>
      </S.AboutSliderWrapper>
    </Element>
  )
}

export default AboutSlider
